import { RespApp } from '@vas2t-lowcode/api';
import mitt, { Emitter } from 'mitt';
import { IAppPayData, IMyAppFullData } from './my-app';

/**
 * 特殊处理后端接口返回的日期字符串只保留到秒，未包含毫秒
 * @param val
 * @returns
 */
export const getDateObj = (val: number | string) => {
  if (!val) {
    return '';
  }
  // 强行转
  const valNum = parseInt(`${val}000`.slice(0, 13));

  return new Date(valNum);
};

type tMyAppEmitter = Emitter<{
  'on-my-app-del-dialog-show': IMyAppFullData; // 应用删除弹窗显示
  'on-my-app-del': RespApp; // 应用删除
  'on-my-app-pay-closed': void; // 我的应用支付关闭
  'on-my-app-pay-show': IMyAppFullData; // 我的应用支付打开
  '2t-pay-show': IAppPayData; // 打开2t支付弹窗
  'on-my-app-list-update': void; // 更新我的应用列表
  'on-my-app-prop-hide': void; // 隐藏我的应用属性弹出层
  'on-reload-app-search-history': void; // 重新刷新搜索历史数据
}>;

export const MY_APP_EMITTER = 'MY_APP_EMITTER' as MyAppEmitterKey;
export const MY_WORKSPACE_APP_EMITTER = 'MY_WORKSPACE_APP_EMITTER' as MyAppEmitterKey;

export enum MyAppEmitterKey {
  MY_APP_EMITTER = 'MY_APP_EMITTER',
  MY_WORKSPACE_APP_EMITTER = 'MY_WORKSPACE_APP_EMITTER',
}

const _myAppEmitterData = {} as Record<MyAppEmitterKey, tMyAppEmitter>;

/** myApp 事件总池 */
export const getMyAppEmitter = (key: MyAppEmitterKey) => {
  const emitterCode = key || MY_APP_EMITTER; // 默认 MY_APP_EMITTER

  if (!_myAppEmitterData[emitterCode]) {
    _myAppEmitterData[emitterCode] = mitt();
  }

  return _myAppEmitterData[emitterCode];
};

export const destroyMyAppEmitter = (key: MyAppEmitterKey) => {
  const emitterCode = key || MY_APP_EMITTER; // 默认 MY_APP_EMITTER

  if (!_myAppEmitterData[emitterCode]) {
    return;
  }

  _myAppEmitterData[emitterCode].all.clear();
  delete _myAppEmitterData[emitterCode];
};
